import { parseDecimal } from '../shared/ParseDecimal';

export interface DisclosureDataBase {
  partner1Salutation: string;
  partner1FirstName: string;
  partner1LastName: string;
  partner1Street: string;
  partner1HouseNumber: string;
  partner1ZipCode: string;
  partner1City: string;
  partner1RegisterAddress: string;
  partner1Nationality: string;
  partner1Mail: string;
  partner1Phonenumber: string;
  partner1MaritalStatus: string;
  partner1JobType: string;
  partner1AlimonyPersons: string;
  partner1AlimonyChildren: string;
  partner1IdentityCardType: string;
  partner1IdentityCardNumber: string;
  partner1IdentityCardIssuePlace: string;
  partner1IdentityCardIssueAgency: string;
  partner1IdentityCardIssuedOn: string;
  partner1IdentityCardExpirationDate: string;
  partner1DateOfBirth: string;
  partner1CountryOfBirth: string;
  partner1PlaceOfBirth: string;
  partner1NetIncome: string;
  partner1AdditionalIncome: string;
  partner1ProbationaryPeriod: string;
  partner1FixedTermEmploymentContract: string;
  partner1EmploymentContractEndStamp: string;
  partner1NoUSCitizen: string;
  bankAccountOwner: string;
  partner1QualityQuestion1: string;
  partner1QualityQuestion2: string;
  partner1QualityQuestion3: string;
  iban: string;
}
export const disclosureFormName = 'privateperson';

export interface PrivatePersonDisclosureData extends DisclosureDataBase {}

export interface DisclosureInitialDataResponse {
  item: DisclosureInitialData;
}

export interface DisclosureInitialData {
  salutation: string;
  firstName: string;
  lastName: string;
  street: string;
  houseNumber: string;
  zipCode: string;
  city: string;
  phone: string;
  email: string;
  identityCardType: number;
  identityCardNumber: string;
  identityCardIssuedOn: string;
  identityCardIssuedPlace: string;
}

export interface DisclosurePostData {
  salutation: string;
  firstName: string;
  lastName: string;
  street: string;
  houseNumber: string;
  zipCode: string;
  city: string;
  registerAddress: number;
  noUSCitizen: boolean;
  maritalStatus: number;
  phoneNumber: string;
  mail: string;
  identityCardType: number;
  identityCardNumber: string;
  identityCardIssuePlace: string;
  identityCardIssueAgency: string;
  identityCardIssuedOn: string; // Date
  identityCardExpirationDate: string; // Date
  dateOfBirth: string; // Date
  placeOfBirth: string;
  countryOfBirth: string;
  alimonyPersons: number;
  alimonyChildren: number;
  jobType: number;
  probationPeriod: boolean;
  termEmploymentContract: boolean;
  employmentContractEndStamp: string; // Date
  netIncome: number;
  additionalIncome: number;
  qualitative1: boolean;
  qualitative2: boolean;
  qualitative3: boolean;
  accountOwner: string;
  iban: string;
  nationality: string;

}

export const mapFormDataToPostData = (formData: PrivatePersonDisclosureData): DisclosurePostData => {
  return {
    salutation: formData.partner1Salutation,
    firstName: formData.partner1FirstName,
    lastName: formData.partner1LastName,
    street: formData.partner1Street,
    houseNumber: formData.partner1HouseNumber,
    zipCode: formData.partner1ZipCode,
    city: formData.partner1City,
    registerAddress: parseInt(formData.partner1RegisterAddress, 10),
    noUSCitizen: formData.partner1NoUSCitizen === '1',
    maritalStatus: parseInt(formData.partner1MaritalStatus, 10),
    phoneNumber: formData.partner1Phonenumber,
    mail: formData.partner1Mail,
    identityCardType: parseInt(formData.partner1IdentityCardType, 10),
    identityCardNumber: formData.partner1IdentityCardNumber,
    identityCardIssuePlace: formData.partner1IdentityCardIssuePlace,
    identityCardIssueAgency: formData.partner1IdentityCardIssueAgency,
    identityCardIssuedOn: formData.partner1IdentityCardIssuedOn,
    identityCardExpirationDate: formData.partner1IdentityCardExpirationDate,
    dateOfBirth: formData.partner1DateOfBirth,
    countryOfBirth: formData.partner1CountryOfBirth,
    placeOfBirth: formData.partner1PlaceOfBirth,
    alimonyPersons: parseInt(formData.partner1AlimonyPersons, 10),
    alimonyChildren: parseInt(formData.partner1AlimonyChildren, 10),
    jobType: parseInt(formData.partner1JobType, 10),
    probationPeriod: formData.partner1ProbationaryPeriod === '1',
    termEmploymentContract: formData.partner1FixedTermEmploymentContract === '1',
    employmentContractEndStamp: formData.partner1EmploymentContractEndStamp,
    netIncome: parseDecimal(formData.partner1NetIncome),
    additionalIncome: parseDecimal(formData.partner1AdditionalIncome),
    qualitative1: formData.partner1QualityQuestion1 === '1',
    qualitative2: formData.partner1QualityQuestion2 === '1',
    qualitative3: formData.partner1QualityQuestion3 === '1',
    accountOwner: formData.bankAccountOwner,
    iban: formData.iban,
    nationality: formData.partner1Nationality
  };
};



// WEBPACK FOOTER //
// ./src/model/disclosureData.tsx